import React from "react";
import {InitAppComponent} from "../init";
import {PRIVY_ID} from "../config";
import {PrivyProvider} from "@privy-io/react-auth";
import {rootStore, StoreContext} from "../stores/root";


export const ContextComponent = (props: { children: React.ReactNode }) => {
    return (
        <PrivyProvider
            appId={PRIVY_ID || ""}
        >
            <StoreContext.Provider value={rootStore}>
                <InitAppComponent>
                    {props.children}
                </InitAppComponent>
            </StoreContext.Provider>
        </PrivyProvider>
    )
}